// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuHeaderComponent_wrapper__qK0nU","line":"MenuHeaderComponent_line__72UMw","lineEnd":"MenuHeaderComponent_lineEnd__05YaK"};